import { useNavigate } from "react-router-dom";
import Button from "../components/ui/Button";

export default () => {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 text-slate-900">
      <div className="space-y-6 text-center">
        <h1 className="text-8xl font-semibold text-slate-100">404</h1>
        <div className="-mt-12 space-y-2">
          <p className="text-xl font-semibold tracking-tight">Gateway Refused</p>
          <p className="text-sm font-bold text-slate-400">Resource not provisioned or moved.</p>
        </div>
        <Button onClick={() => navigate("/")} className="text-xs font-semibold">Return to Gateway</Button>
      </div>
    </div>
  );
};
